import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Mouthpiece from "../pages/mouthpiece/page";
import Whitening from "../pages/whitening/page";
import Philosophy from "../pages/philosophy/page";
import ColumnList from "../pages/column/ColumnList";
import ColumnDetail from "../pages/column/ColumnDetail";
import NewsList from "../pages/news/NewsList";
import NewsDetail from "../pages/news/NewsDetail";
import Icon from "../pages/icon/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mouthpiece/",
    element: <Mouthpiece />,
  },
  {
    path: "/mouthpiece",
    element: <Navigate to="/mouthpiece/" replace />,
  },
  {
    path: "/whitening/",
    element: <Whitening />,
  },
  {
    path: "/whitening",
    element: <Navigate to="/whitening/" replace />,
  },
  {
    path: "/philosophy/",
    element: <Philosophy />,
  },
  {
    path: "/philosophy",
    element: <Navigate to="/philosophy/" replace />,
  },
  {
    path: "/icon/",
    element: <Icon />,
  },
  {
    path: "/icon",
    element: <Navigate to="/icon/" replace />,
  },
  {
    path: "/column/",
    element: <ColumnList />,
  },
  {
    path: "/column",
    element: <Navigate to="/column/" replace />,
  },
  {
    path: "/column/:slug/",
    element: <ColumnDetail />,
  },
  {
    path: "/column/:slug",
    element: <ColumnDetail />,
  },
  {
    path: "/news/",
    element: <NewsList />,
  },
  {
    path: "/news",
    element: <Navigate to="/news/" replace />,
  },
  {
    path: "/news/:slug/",
    element: <NewsDetail />,
  },
  {
    path: "/news/:slug",
    element: <NewsDetail />,
  },
  // 旧URL（日付付き）→ 新URLへクライアントサイドリダイレクト
  {
    path: "/mouthpiece-20260103",
    element: <Navigate to="/mouthpiece/" replace />,
  },
  {
    path: "/mouthpiece-20260103/",
    element: <Navigate to="/mouthpiece/" replace />,
  },
  {
    path: "/whitening-20260103",
    element: <Navigate to="/whitening/" replace />,
  },
  {
    path: "/whitening-20260103/",
    element: <Navigate to="/whitening/" replace />,
  },
  {
    path: "/philosophy-20260103",
    element: <Navigate to="/philosophy/" replace />,
  },
  {
    path: "/philosophy-20260103/",
    element: <Navigate to="/philosophy/" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;